import { AuthenticationResponse } from "../interfaces/authentication/AuthenticationResponse";

export const getAuthenticationToken = (): string | null => {
  const user = JSON.parse(localStorage.getItem("user") || "null") as AuthenticationResponse | null;
  return user?.accessToken || null;
};

export const getAuthenticationHeaders = (): Record<string, string> => {
  const token = getAuthenticationToken();
  return token ? { Authorization: `Bearer ${token}` } : {};
};